import styled, { css } from 'styled-components';

type FormPropsType = {
  noScroll?: boolean;
  showBorder?: boolean;
  margin?: string;
  mg?: string;
  pd?: string;
  maxWidth?: string;
};

export const ChipStyleMixin = css`
  padding: 4px 8px;
  font-size: 12px;
  line-height: 14px;
`;

export const FormContainer = styled.form<{ height?: string }>`
  display: flex;
  flex-direction: column;
  height: ${({ height }) => height || '100%'};
  overflow: auto;
  flex: 1;
  .disclaimer {
    padding: 25px;
    .disclaimer-text {
      font-size: 14px;
      font-weight: 600;
      color: #12344d;
    }
    .checkbox {
      align-self: flex-start;
      margin-top: 5px;
    }
  }
`;

export const StyledTags = styled.div<{ isNotEmpty?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: ${({ height }) => height || '100%'};
  overflow: auto;
  flex: 1;
  border-radius: 5px;
  text-overflow: ellipsis;
  .table-content {
    margin-top: 0px !important;
    height: calc(100% - 66px);
  }
  table {
    table-layout: fixed;

    th:first-child {
      width: 400px !important;
    }
  }

  .header-row {
    position: sticky;
    top: 0;
    z-index: 3;
    background: #f5f7f9;
  }

  td > div {
    max-width: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .input-basic {
    border-color: transparent !important;
  }
  input,
  input:hover {
    border-color: transparent !important;
    background-color: transparent !important;
    padding-left: 0px !important;
    text-overflow: ellipsis;
  }

  .table-actions {
    justify-content: flex-end;
    position: fixed;
    bottom: 0;
    width: 80%;
    right: 15px;
    border-bottom: 0;
    background: #fff;
    z-index: 1100;
    box-shadow: none;
  }

  ${({ isNotEmpty }) =>
    isNotEmpty
      ? `.pagination-text:before {
            content: 'Showing ';
          }`
      : `.pagination-actions {
            visibility: hidden;
          }`}
`;

export const FormHeader = styled.div<{ hideBorder?: boolean }>`
  margin: 0 24px;
  padding: 24px 0;
  border-bottom: ${({ hideBorder }) =>
    hideBorder ? 'unset' : '1px solid #d3d3d3'};
  display: flex;
  div.left-pane {
    flex: 1;
    margin-right: 12px;
  }
  .dkim-tooltip {
    padding-top: 20px;
  }
  div.right-pane,
  div.left-pane {
    display: flex;
    align-items: center;
    button {
      margin: 0;
    }
    & > :not(:last-child) {
      margin-right: 12px;
    }

    & #import-template-btn {
      display: flex;
      align-items: center;
      gap: 6px;
    }
  }
  div.heading {
    font-weight: 600;
    font-size: 18px;
    line-height: 21px;
    color: #12344d;
    :not(:last-child) {
      margin-bottom: 14px;
    }
  }
  div.sub-heading {
    font-size: 12px;
    line-height: 14px;
    color: #12344d80;
    font-weight: 400;
  }
  div.helptext {
    font-size: 11px;
    line-height: 20px;
    color: #475867;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
  }
`;

export const FormContent = styled.div<FormPropsType>`
  max-width: ${({ maxWidth }) => maxWidth || 'unset'};
  overflow: ${({ noScroll }) => (noScroll ? 'unset' : 'auto')};
  flex: 1;
  scroll-behavior: smooth;
  margin: ${({ mg }) => mg || '0'};
  padding: ${({ pd }) => pd || '24px'};
  label {
    color: #12344d;
  }
`;

export const FormSection = styled.div<FormPropsType>`
  max-width: ${({ maxWidth }) => maxWidth || 'unset'};
  border-bottom: ${({ showBorder }) =>
    showBorder ? '1px solid #d3d3d3' : 'unset'};
  padding-bottom: ${({ showBorder }) => (showBorder ? '32px' : 'unset')};
  font-size: 14px;
  .section-name {
    user-select: none;
    display: flex;
    font-size: 14px;
    line-height: 14px;
    color: #7c7c7c;
    align-items: center;
    margin-bottom: 24px;
    div.line {
      margin: 0 16px;
      flex-grow: 1;
      border-bottom: 1px solid #ececec;
    }
  }
  span.required {
    color: var(--text-danger);
  }
  :not(:last-child) {
    margin-bottom: 48px;
  }
`;

export const FormField = styled.div<{ mini?: boolean }>`
  position: relative;
  &.flex {
    display: flex;
    & > :not(:last-child) {
      margin-right: 12px;
    }
  }
  &.flex-wrap {
    display: flex;
    flex-wrap: wrap;
    div {
      margin: 0 !important;
    }

    align-items: center;
    gap: 4px;
    & > :not(:last-child) {
      margin-right: 12px;
    }
    .limitReset-field {
      margin: 0 0 0 175px !important;
    }
  }
  .max-limit {
    div {
      display: flex !important;
      align-items: center;
    }
  }

  :not(:last-child) {
    margin-bottom: 24px;
  }
  .input-basic {
    :focus-within {
      div.end-max-length {
        display: block;
      }
    }
    div.end-max-length {
      display: none;
    }
    input[type='time'] {
      width: unset;
    }
    input[type='number'] {
      width: 60px;
    }
    input[type='number']::-webkit-inner-spin-button,
    input[type='number']::-webkit-outer-spin-button {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      margin: 0;
    }
    input[type='datetime-local'] {
      width: 220px;
      text-align: unset;
    }
  }
  div.sub-heading {
    font-size: 12px;
    line-height: 14px;
    color: #12344d80;
    font-weight: 400;
  }
  div.heading {
    font-weight: 600;
    font-size: 14px;
    color: #12344d;
    :not(:last-child) {
      margin-bottom: 24px;
    }
  }
  div.filter-value {
    flex: 1;
    margin-top: 8px;
    :not(:last-child) {
      margin-bottom: 8px;
    }
    div.condition {
      text-align: center;
      margin: 4px 0;
      font-size: 12px;
    }
    div.input-container {
      background: #ffffff;
    }
  }
  div.field-hint {
    :last-child {
      margin-top: 8px;
    }
    font-size: 12px;
    color: #0851dd;
    text-align: end;
    :hover {
      text-decoration: underline;
    }
  }
  div.action {
    position: absolute;
    right: 0;
    cursor: pointer;
    z-index: 1;
    div.clear-filter {
      display: none;
      margin: 8px 0;
      font-size: 12px;
      line-height: 14px;
      color: #2c5cc5;
      span {
        margin-left: 4px;
      }
    }
  }
  :hover {
    .clear-filter {
      display: block !important;
    }
  }

  .custom-label {
    padding-bottom: 8px;
    padding-left: 2px;
    font-size: 12px;
    font-weight: 400;
  }

  label.input-label {
    color: #12344d;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
  }

  .hint {
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    color: #7d7d7d;
    margin-bottom: 4px;
    word-break: break-word;
  }

  &.error {
    [id*='dropdownField'] {
      border: 1px solid transparent !important;
      box-shadow: 0 0 0 2px var(--text-danger) !important;
    }
  }
  .svg-wrapper {
    display: none;
  }
  div[aria-labelledby='addToLists-label'] {
    label {
      text-transform: unset;
    }
  }
  &.bottom-sticky {
    position: sticky;
    bottom: 0;
    background: #f5f7f9;
    margin: -2px;
  }
  &.add-filter {
    margin-bottom: 24px;
  }
`;

export const FormActions = styled.div<{
  hideBorder?: boolean;
}>`
  .contact-button-style {
    display: flex;
    gap: 10px;
    button {
      margin: 0 !important;
    }
  }
  padding: 16px;
  display: flex;
  justify-content: space-between;
  border-top: ${({ hideBorder }) =>
    hideBorder ? 'unset' : '0.5px solid rgb(232, 232, 232)'};
  align-items: center;
  background: #f5f7f9;
  div.right-pane,
  div.left-pane {
    display: flex;
    align-items: center;
    button {
      margin: 0;
    }
    & > :not(:last-child) {
      margin-right: 16px;
    }
  }
`;

export const FormSideBar = styled.aside<{ width?: string }>`
  border-right: 1px solid #cfd7df;
  width: ${({ width }) => width || '280px'};
  overflow: auto;
  div.group-heading {
    padding: 22px 26px;
    font-weight: bold;
    font-size: 24px;
    line-height: 32px;
    letter-spacing: 0.8px;
    color: #12344d;
  }
  div.group-items {
    padding: 12px;
  }
  div.group-item {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.08px;
    color: #12344d;
    height: 44px;
    padding: 12px 16px;
    border-radius: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &.error {
      color: var(--text-danger);
    }
    span.error {
      color: var(--text-danger);
      padding-left: 4px;
    }
    &.active {
      background: #eef2f5;
      font-weight: 600;
      transition: background 0.3s ease-out;
    }
    :not(:last-child) {
      margin-bottom: 4px;
    }
    :hover {
      cursor: pointer;
    }
  }
`;

export const FormHolder = styled.div<{ height?: string }>`
  display: flex;
  flex-grow: 1;
  height: 100%;
  overflow: auto;
`;

export const MiniFormHeader = styled.div<{ hideBorder?: boolean }>`
  color: #12344d;
  border-bottom: 1px solid #d3d3d3;
  padding: 14px 16px 10px;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  justify-content: space-between;
  .segment-filter {
    cursor: pointer;
    color: #2c5cc5;
    text-transform: none;
  }
`;

export const Center = styled.div<{ minHeight: string }>`
  min-height: ${({ minHeight }) => minHeight || 'unset'};
  height: 100%;
  width: 100%;
  display: grid;
  place-content: center;
  & > div:first-child {
    margin: 16px auto;
  }
  div {
    text-align: center;
    color: #000000;
  }
  div.text {
    font-weight: 600;
    margin-bottom: 8px;
    font-size: 14px;
  }
  div.sub-text {
    font-weight: normal;
    font-size: 13px;
  }
`;

type LastSeparateMenuProps = {
  maxHeight?: string;
  seperator?: boolean;
  seperatorPositionFromLast?: number;
  seperatedItemColor?: string;
};

export const LastSeparateMenu = styled.div<LastSeparateMenuProps>`
  ${({ maxHeight }) =>
    maxHeight ? `max-height: ${maxHeight || '100px'}; overflow: auto;` : ''}
  ${({ seperator, seperatorPositionFromLast = 1 }) =>
    seperator
      ? `ul {
    li:nth-last-child(${seperatorPositionFromLast}) {
      border-top: 1px solid #ececec;
    }
  }`
      : ''}
      ${({ seperatedItemColor, seperatorPositionFromLast = 1 }) =>
    seperatedItemColor
      ? `ul {
      li:nth-last-child(-n + ${seperatorPositionFromLast}){
        color: ${seperatedItemColor};
      }
    }`
      : ''}
  
  box-shadow: 0 2px 4px 0 rgb(24 50 71 / 8%);
`;

export const FreshLink = styled.a`
  font-weight: 600;
  font-size: 12px;
  line-height: 22px;
  color: var(--text-link) !important;
  :hover {
    text-decoration: underline !important;
  }
`;

export const ErrorField = styled.div.attrs({
  'aria-live': 'assertive',
  role: 'status',
})`
  color: var(--text-danger);
  font-size: 12px;
  padding-left: 4px;
  margin-top: 4px;
`;

type TabContainerProps = {
  padding?: string;
  boxShadow?: string;
};

export const TabContainer = styled.div<TabContainerProps>`
  padding: ${({ padding }) => padding || '16px 16px 0 16px'};
  z-index: 1;
  background: #ffffff;
  box-shadow: ${({ boxShadow }) =>
    boxShadow ? '0px 2px 4px rgba(207, 215, 223, 0.3)' : 'unset'};
  border-bottom: 1px solid var(--color-smoke-50);
  margin-bottom: 8px;
  border-radius: 4px;
  div[role='tab'] {
    margin-right: 24px;
  }
`;

export const DrawerMenuContainer = styled.div<{ $isResponse: boolean }>`
  ${(props) =>
    !props.$isResponse &&
    `background: #f1f4f6;
    padding: 12px;`}
  height: 100%;
  div.filter-view-heading {
    margin: 10px 0 10px 5px;
    font-size: 12px;
    font-weight: 600;
  }
  div.filter-views-container {
    margin-left: 15px;
    p.fv-gp-head {
      font-size: 12px;
      color: #7b8e9f;
      margin: 0;
    }
  }
`;

export const DrawerMenuList = styled.div<{ $isResponse: boolean }>`
  ${(props) => !props.$isResponse && 'padding: 12px;'}
  background: #ffffff;
  overflow: auto;
  height: 100%;
  border-radius: 3px;
  div.drawer-menu-item {
    border-radius: 4px;
    height: 42px;
    cursor: pointer;
    font-weight: 400;
    font-size: 14px;
    padding: 0 16px;
    color: #12344d;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &.selected {
      background: #e5f2fd;
      cursor: not-allowed;
    }
    :hover:not(.none) {
      background: #e5f2fd;
      .d-menu-ic-holder {
        display: flex;
      }
    }
    :not(:last-child) {
      margin-bottom: 8px;
    }
    &.filter-view {
      box-sizing: content-box;
      .d-menu-ic-holder {
        cursor: pointer;
        display: none;
        column-gap: 15px;
        color: #c82124;
        padding: 2px 6px;
        border-radius: 3px;
      }
      &.selected-filter {
        background: #e5f2fd;
        > span {
          font-size: 14px;
          font-weight: bold;
        }
        .d-menu-ic-holder {
          display: flex;
        }
      }
    }
  }
`;
